import React, { Component, Fragment } from 'react'
import { withCookies } from 'react-cookie'
import { withStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import Toolbar from '@material-ui/core/Toolbar';
import SyncIcon from '@material-ui/icons/Sync';
import ClearIcon from '@material-ui/icons/Clear';
import AddIcon from '@material-ui/icons/Add';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import CustomCircularProgress from '../../../custom/CustomCircularProgress';
import GroupApi from '../../../../libs/EdgeVMSCloudApi/Groups'
import { SERVICES, OPERATIONS } from '../../../../constants/permissions'
import CustomTable from '../../../custom/CustomTable';
import CustomTableHead from '../../../custom/CustomTableHead';
import SearchBox from '../../../custom/SearchBox'
import { GetNavParamsFromLocation } from '../../../../libs/Utils'
import { NavTableFooter } from '../../../table'
import ROWS_PER_PAGE_OPTIONS from '../../../../constants/navParams'
import { COOKIES } from '../../../../constants/cookieDefs'
import { ConfirmAction, SelectRoleDialog } from '../../../dialogs'

const useStyles = theme => ({
  root: {
    width: '100%',
    overflowX: 'auto',
    display: 'flex',
  },
  container: {
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(4),
  },
  title: {
    flexGrow: 1,
    color: theme.palette.secondary.main,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 240,
  },
  actionsCell: {
    textAlign: 'center',
    whiteSpace: 'nowrap',
  },
});

class GroupRolesTab extends Component {
  constructor (props) {
    super(props)

    const { cookies } = props;
    const DefaultNavParams = {
      currentPage: '0',
      rowsPerPage: cookies.get(COOKIES.ROWS_PER_PAGE.name),
      searchString: "",
    }

    this.state = {
      isLoading: true,
      showActionProgress: false,
      confirmDeleteActionOpen: false,
      selectRoleDialogOpen: false,
      group: {},
      groupRoles : {},
      hasDataError: false,
    }

    this.roleInAction = null
    this.navParams = GetNavParamsFromLocation(DefaultNavParams)
    this.abortController = new AbortController();
    this.signal = this.abortController.signal;
  }

  async componentDidMount () {
    await this.handleRefresh()
  }

  componentWillUnmount () {
    this.abortController.abort();
  }

  async handleRefresh () {
    if (!this.props.newGroup && this.props.match.params.group) {

      this.setState({isLoading: true})

      let response = await GroupApi.FetchGroup(this.signal, this.props.match.params.group)
      if (response.error && response.error.name === "AbortError") {
        return;
      }

      this.setState ({group: response.ok ? response.body : {}})

      if (response.ok) {
        response = await GroupApi.FetchGroupRoles(this.signal, this.props.match.params.group, this.navParams)
        if (response.error && response.error.name === "AbortError") {
          return;
        }

        this.setState({groupRoles: response.ok ? response.body : {}})
      } else {
        this.setState({groupRoles:  {}})
      }

      this.setState({hasDataError: response.error ? true : false}, () => this.setState({isLoading: false}))
    } else {
      this.setState({isLoading: false})
    }
  };

  handleRequestSearch (event, value) {
    let currentParams = new URLSearchParams(window.location.search)
    currentParams.set('currentPage', '0')

    if (value.length) {
      currentParams.set('searchString', value)
    } else {
      currentParams.delete('searchString')
    }

    window.location.search = currentParams.toString()
  };

  onDeleteActionClick (roleInAction) {
    if (roleInAction)
    {
      this.roleInAction = roleInAction
      this.setState({showActionProgress: false})
      this.setState({confirmDeleteActionOpen: true})
    }
  }

  async DeleteActionCallback (userAnswer, toDelete) {
    if (userAnswer && userAnswer === 'ok' && toDelete && toDelete.id) {
      this.setState({showActionProgress: true})

      let response = await GroupApi.DeassignRole(this.signal, this.props.match.params.group, toDelete.id)
      if (response.error && response.error.name === "AbortError") {
        return;
      }

      await this.handleRefresh()
    }
    this.setState({confirmDeleteActionOpen: false})
  };


  render () {
    const { classes, session, newGroup } = this.props
    const { isLoading, group, groupRoles, hasDataError } = this.state
    const { currentPage, rowsPerPage, searchString } = this.navParams
    const originLocation = this.props.location.state ? this.props.location.state.originLocation : undefined
    const hasUpdatePermission = session.permissions[SERVICES.USER][OPERATIONS.UPDATE]

    if (newGroup) {
      return null
    }

    let { total, offset, roles } = groupRoles
    if (roles == null) {
      roles = []
    }

    if (total == null) {
      total = 0
    }

    if (offset == null) {
      offset = 0
    }

    return (
      <div className={classes.root}>
        <Container maxWidth="md" className={classes.container}>
          <Toolbar>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small"/>} color="inherit" aria-label="breadcrumb" className={classes.title}>
              <Link component="button" variant="h6" href="/" color="inherit" title='Back To Groups'
                onClick={() => originLocation ? window.location.href = originLocation : this.props.history.push('/mainmenu/admin/groups')}
              >
                Groups
              </Link>
              { group.name &&
                <Link component="button" variant="h6" href="/" color="inherit" title='Back to Details'
                  onClick={() => this.props.history.push(this.props.location.pathname.substring(0, this.props.location.pathname.lastIndexOf('/')), this.props.location.state)}
                >
                  { group.name }
                </Link>
              }
              { group.name &&
                <Typography component="h1" variant="h6" color="inherit" noWrap>
                  Roles
                </Typography>
              }
            </Breadcrumbs>
            <Tooltip title="Back">
              <span>
                <IconButton id="go-back-icon" disabled={isLoading} onClick={this.props.history.goBack.bind(this)}>
                  <ArrowBackIcon />
                </IconButton>
              </span>
            </Tooltip>

            { hasUpdatePermission &&
              <Tooltip title={"Add Role To Group"}>
                <span>
                  <IconButton id="add-role-icon" disabled={isLoading || hasDataError} onClick={() => this.setState({selectRoleDialogOpen: true})}>
                    <AddIcon />
                  </IconButton>
                </span>
              </Tooltip>
            }

            <Tooltip title="Refresh">
              <span>
                <IconButton id="refresh-icon" disabled={isLoading} onClick={this.handleRefresh.bind(this)}>
                  <SyncIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Toolbar>
          <Box display="flex" justifyContent="flex-end">
            <SearchBox
              className={classes.formControl}
              disabled={isLoading}
              onSearch={this.handleRequestSearch}
              searchString={searchString}
            />
          </Box>
          { isLoading ? (
            <CustomCircularProgress />
          ) : (
            <Fragment>
              <CustomTable>
                <CustomTableHead>
                  <TableRow selected={true}>
                    <TableCell>Name</TableCell>
                    <TableCell>Description</TableCell>
                    { hasUpdatePermission &&
                      <TableCell align="center">Actions</TableCell>
                    }
                  </TableRow>
                </CustomTableHead>
                {roles.length ? (
                  <TableBody>
                    {roles.map((role) => {
                      return (
                        <TableRow hover key={role.id}>
                          <TableCell title="Click To View Role Details" onClick={() => this.props.history.push("/mainmenu/admin/roles/details/" + role.id)}>
                            {role.name}
                          </TableCell>
                          <TableCell title="Click To View Role Details" onClick={() => this.props.history.push("/mainmenu/admin/roles/details/" + role.id)}>
                            {role.description}
                          </TableCell>
                          { hasUpdatePermission &&
                            <TableCell className={classes.actionsCell}>
                              <Tooltip title="Remove From Group">
                                <IconButton
                                  size={'small'}
                                  onClick={this.onDeleteActionClick.bind(this, role)}
                                >
                                  <ClearIcon fontSize={'small'} />
                                </IconButton>
                              </Tooltip>
                            </TableCell>
                          }
                        </TableRow>
                    )})}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell align='center' colSpan={hasUpdatePermission ? 3 : 2}>No Roles Assigned</TableCell>
                    </TableRow>
                  </TableBody>
                )}
                <NavTableFooter
                  labelRowsPerPage='Roles per page'
                  rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                  count={total}
                  rowsPerPage={parseInt(rowsPerPage, 10)}
                  currentPage={total > 0 ? parseInt(currentPage, 10) : 0}
                />
              </CustomTable>
            </Fragment>
          )}
        </Container>

        <SelectRoleDialog
          open={this.state.selectRoleDialogOpen === true}
          session={session}
          parentGroup={group}
          accountFilter={group.account_id}
          doneCallback={() => this.setState({selectRoleDialogOpen: false}, () => this.handleRefresh())}
          assignRole={async (signal, roleId) => await GroupApi.AssignRole(signal, group.id, roleId)}
          deassignRole={async (signal, roleId) => await GroupApi.DeassignRole(signal, group.id, roleId)}
        />

        <ConfirmAction
          title="Remove Role From Group ?"
          open={this.state.confirmDeleteActionOpen === true}
          showProgress={this.state.showActionProgress}
          progressMsg="Processing request to remove role from group..."
          actionCallback={this.DeleteActionCallback.bind(this)}
          callbackContext={this.roleInAction}
        >
          {`Are you sure you want to remove ${this.roleInAction ? "\"" + this.roleInAction.name + "\"" : "this"} role from ${group.name ? "\"" + group.name + "\"" : "this"} group ?`}
        </ConfirmAction>

      </div>
    )
  }
}

export default withCookies(withStyles(useStyles)(GroupRolesTab))
